export default class LinkedSet {
    constructor(maxSize = 100) {
        this.maxSize = maxSize;
        this.set = new Set();
        this.order = [];
    }

    add(uuid) {
        if (!this.set.has(uuid)) {
            this.set.add(uuid);
            this.order.push(uuid);

            if (this.set.size > this.maxSize) {
                const oldest = this.order.shift();
                this.set.delete(oldest);
            }
        }
        return this;
    }

    delete(uuid) {
        if (this.set.has(uuid)) {
            this.set.delete(uuid);
            const index = this.order.indexOf(uuid);
            if (index > -1) {
                this.order.splice(index, 1);
            }
        }
        return this;
    }

    has(uuid) {
        return this.set.has(uuid);
    }

    clear() {
        this.set.clear();
        this.order = [];
    }

    get size() {
        return this.set.size;
    }

    *[Symbol.iterator]() {
        yield* this.order;
    }
}
